import React, { Component, Fragment } from 'react';
import DevoteeGrid from './grid/DevoteeGrid.js';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/styles';
import { styles } from './DevoteeContainer.styles';
import { theme } from '../../layout/Layout.theme';
import { Messages } from '../../_locale/locale.en';

class DevoteeContainer extends Component {
  render () {
    const { classes } = this.props;
    return (
      <Fragment>
        <Button variant="contained" color="secondary" className={classes.button}>
          {Messages.DevoteeContainer.Buttons.AddDevotee}
        </Button>
        <p></p>
        <DevoteeGrid />
      </Fragment>
    )
  }
}

export default (
  withStyles(
    styles,
    {
      defaultTheme: theme,
      withTheme: true,
      name: 'layout',
    }
  )(DevoteeContainer));

